var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c(_vm.component,_vm._b({tag:"component",class:[_vm.gridAlignmentClassName]},'component',{ departments: _vm.departments },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }